// extracted by mini-css-extract-plugin
export default {"noScroll":"NoScroll-noScroll-e3d04b6e68f2b8619fb2a2149f6e718e"};